const mockTransFunc = (arg: string) => arg

export const Language = {
  en: mockTransFunc('language:en'),
  pt: mockTransFunc('language:pt'),
  ru: mockTransFunc('language:ru'),
}

export const Warning = {
  max: {
    50: mockTransFunc('common:warning.max.50'),
    100: mockTransFunc('common:warning.max.100'),
  },
  required: mockTransFunc('common:warning.required'),
}

export const SignerValidation = {
  fullName: mockTransFunc('common:validation.fullName'),
  position: mockTransFunc('common:validation.position'),
  initials: mockTransFunc('common:validation.initials'),
}
